import { DateTimeUnit, DurationUnit } from 'luxon';

enum DateTimePart {
    Year = 'Year',
    Quarter = 'Quarter',
    Month = 'Month',
    Week = 'Week',
    Date = 'Date',
    Day = 'Day',
    Hour = 'Hour',
    Hours = 'Hours',
    Minutes = 'Minutes',
    Seconds = 'Seconds',
    Milliseconds = 'Milliseconds',
}

export const unitByDateTimePart: Record<DateTimePart, DateTimeUnit> = {
    [DateTimePart.Year]: 'year',
    [DateTimePart.Quarter]: 'quarter',
    [DateTimePart.Month]: 'month',
    [DateTimePart.Week]: 'week',
    [DateTimePart.Date]: 'day',
    [DateTimePart.Day]: 'day',
    [DateTimePart.Hour]: 'hour',
    [DateTimePart.Hours]: 'hour',
    [DateTimePart.Minutes]: 'minute',
    [DateTimePart.Seconds]: 'second',
    [DateTimePart.Milliseconds]: 'millisecond',
};

export const durationUnitByDateTimePart: Record<DateTimePart, DurationUnit> = {
    [DateTimePart.Year]: 'years',
    [DateTimePart.Quarter]: 'quarter',
    [DateTimePart.Month]: 'months',
    [DateTimePart.Week]: 'weeks',
    [DateTimePart.Date]: 'days',
    [DateTimePart.Day]: 'days',
    [DateTimePart.Hour]: 'hours',
    [DateTimePart.Hours]: 'hours',
    [DateTimePart.Minutes]: 'minutes',
    [DateTimePart.Seconds]: 'seconds',
    [DateTimePart.Milliseconds]: 'milliseconds',
};

export default DateTimePart;
